// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Wd59P","title":"styles_title__3RFY6","desc":"styles_desc__sKEKz"};